import React from 'react';
import DModalClaudeModels from '@/components/DModalClaudeModels';
import useClaudeModelsModal from '@/hooks/useClaudeModelsModal';

/**
 * ClaudeModelsModalContainer
 *
 * This component manages the Claude Models Modal display.
 * It should be included in the GlobalModals component.
 *
 * The modal will:
 * - Show once per user when they log in
 * - Display in the bottom-right corner with a slide-in animation
 * - Track the view on the backend with event: "Pop-Up Claude New Models"
 */
const ClaudeModelsModalContainer = () => {
  const { isOpen, handleClose, handleTryNow } = useClaudeModelsModal();

  const handleClose_ = () => {
    handleClose();
  };

  const handleTryNow_ = () => {
    handleTryNow();
  };

  return (
    <DModalClaudeModels
      isOpen={isOpen}
      onClose={handleClose_}
      onTryNow={handleTryNow_}
      position="bottom-right"
    />
  );
};

export default ClaudeModelsModalContainer;

